import { getError, HttpError, NetworkError } from './errors';

export type Fetcher = <T = any>(url: string | [string, RequestInfo], config?: RequestInit) => Promise<T>;

const getContent = (response: Response) => {
  const contentType = response.headers.get('content-type');
  if (contentType?.includes('application/json')) {
    return response.json();
  }

  if (contentType?.includes('application/zip') || contentType?.includes('application/pdf')) {
    return response.blob();
  }

  return response.text();
};

const getApi =
  (token: string): Fetcher =>
  async <T = any>(url: string | [string, RequestInfo], config: RequestInit = {}) => {
    let urlString = '';
    let overrides: Partial<Request> = {};
    if (typeof url === 'string') {
      urlString = url;
    } else {
      urlString = url[0];
      overrides = url[1] as Request;
    }

    config.headers = {
      ...config.headers,
      authorization: `Bearer ${token}`,
      'content-type': 'application/json',
    };
    config.method = 'POST';
    config = { ...config, ...overrides };

    let response: Response;
    try {
      response = await fetch(__CONFIG__.API_URL + urlString, config);
    } catch (error) {
      throw new NetworkError(getError(error)?.message);
    }

    if (!response.ok) {
      let content;
      try {
        content = await getContent(response);
      } catch (e) {
        // can not decode response.
        throw new HttpError(response.status, response.statusText);
      }

      throw new HttpError(response.status, response.statusText, JSON.stringify(content));
    }

    return getContent(response) as Promise<T>;
  };

export default getApi;
